<template>
  <div class="page">

    <div v-show="adminMode || partnerMode">
      <h1>Partner settings</h1>
      Global partner settings affecting to all accounts.
      <SettingsPartner :partner="partner"/>
    </div>

    <div>
      <h1>Account settings</h1>
      <SettingsAccount :account="account"/>
    </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hint {
  font-size: small;
}
</style>

<script>
import { mapState } from 'vuex'
import SettingsPartner from '@/components/SettingsPartner.vue'
import SettingsAccount from '@/components/SettingsAccount.vue'

export default {
  name: 'settings',
  components: {
    SettingsAccount,
    SettingsPartner
  },
  computed: {
    ...mapState([
      'adminMode',
      'partnerMode',
      'accountMode',
      'debugMode',
      'partner',
      'account',
    ])
  }
}
</script>
